<app-navigation
    [additionalContainerClasses]="[]"
    [automaticFooterPadding]="false">
    <app-user-login></app-user-login>
</app-navigation>
